const helper = {
  getGroupBarFromHistmetrics: ({ perfHistmetrics }) => {
    let res = [];
    if (!perfHistmetrics || perfHistmetrics.length === 0) return;

    const getValues = ({ i }) => {
      let values = [];
      let obj1 = {};
      let obj2 = {};

      obj1["value"] = perfHistmetrics[i]["fund_return"] * 100;
      obj1["group"] = "portfolio";

      obj2["value"] = perfHistmetrics[i]["bm_return"] * 100;
      obj2["group"] = "benchmark";
      values.push(obj1, obj2);

      return values;
    };
    for (let i = 0; i < perfHistmetrics.length; i++) {
      let obj = {};

      if (perfHistmetrics[i].metric_name === "1 Year") {
        obj["categorie"] = "1 YR";
        let values = getValues({ i });
        obj["values"] = values;

        res.push(obj);
      } else if (perfHistmetrics[i].metric_name === "3 Year") {
        obj["categorie"] = "3 YR";
        let values = getValues({ i });
        obj["values"] = values;

        res.push(obj);
      } else if (perfHistmetrics[i].metric_name === "5 Year") {
        obj["categorie"] = "5 YR";
        let values = getValues({ i });
        obj["values"] = values;

        res.push(obj);
      } else if (perfHistmetrics[i].metric_name === "Since Inception") {
        obj["categorie"] = "YTD";
        let values = getValues({ i });
        obj["values"] = values;

        res.push(obj);
      }
    }
    return res;
  },
};

export default helper;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/model_card/helper.js